import api from './api';

export async function fetchEspecialistas() {
  const resp = await api.get('/especialistas', {
    params: {
      per_page: 10000,
      status: 'active',
    },
  });
  return resp.data?.data || [];
}
